import createCachedSelector from 're-reselect';
import get from 'lodash.get';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import {
  baseColumnsDefaultConfigs,
  defaultColumnConfigurations,
  allSearchResultColumnsConfigs,
} from '../../../store/orders/grid/default-column-configuration';
import { GridConfigService } from '../../../services/grid-config-service';

export const selectOrders = (state) => get(state, 'orders', emptyArray);
export const selectPage = (state) => get(state, 'page');
export const selectPageSize = (state) => get(state, 'pageSize');
export const selectTotalRecords = (state) => get(state, 'totalRecords');
export const selectTotalPages = (state) => get(state, 'totalPages');
export const selectViewStartingCount = (state) => get(state, 'viewStartingCount');
export const selectViewEndingCount = (state) => get(state, 'viewEndingCount');
export const selectIsLoading = (state) => get(state, 'isLoading');
export const selectIsGroupBysCountLoading = (state) => get(state, 'isGroupBysCountLoading');
export const selectisSidebarVisible = (state) => get(state, 'isSidebarVisible');
export const selectUserGridConfigurations = (state) => get(state, 'userViewConfigurations', emptyObject);
export const selectOrderGridRateJobs = (state) => get(state, 'rateJobs', emptyArray);
export const selectAlternativeRateJobs = (state) => get(state, 'alternativeRateJobs', emptyArray);
export const selectActiveGroupByEnums = (state) => get(state, 'activeGroupBys', emptyArray);
export const selectActiveGroupByCount = (state) => get(state, 'groupByCount', emptyArray);
export const selectHasGetOrdersFailure = (state) => get(state, 'hasGetOrdersFailure');

const mergeConfigurationsSelector = createCachedSelector(
  (viewConfiguration) => viewConfiguration,
  (viewConfiguration) => GridConfigService.mergeUserAndDefaultConfigs(viewConfiguration, defaultColumnConfigurations),
)((_, statusViewId, activeFilterViewId) => `${statusViewId}_${activeFilterViewId}`);

const selectCustomViewColumnConfiguration = (state) => get(state, 'customViewColumnConfiguration');
export const selectCurrentViewGridConfigOrDefault = (state, { activeFilterViewId, statusViewId }) => {
  if (activeFilterViewId === 'custom') {
    const viewConfiguration = selectCustomViewColumnConfiguration(state);
    return mergeConfigurationsSelector(viewConfiguration, statusViewId, activeFilterViewId);
  }

  const allGridConfigs = selectUserGridConfigurations(state);
  const { [activeFilterViewId]: configForView } = allGridConfigs[statusViewId] || {};

  if (!configForView) {
    return statusViewId?.includes('all-orders-search-result') ? allSearchResultColumnsConfigs : baseColumnsDefaultConfigs;
  }

  return mergeConfigurationsSelector(configForView, statusViewId, activeFilterViewId);
};

export const selectCurrentOrderByColumn = (state, { activeFilterViewId, statusViewId }) => {
  const gridConfig =
    selectCurrentViewGridConfigOrDefault(state, {
      statusViewId,
      activeFilterViewId,
    }) || emptyArray;

  return gridConfig.find((col) => !!col.sorted);
};
